import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_USER_DATA = 'FETCH_ANALYTIC_USER_DATA';
export const fetchAnalyticUserDataAction = createAction(FETCH_ANALYTIC_USER_DATA);
